import { useLingui } from '@lingui/react/macro'

import * as Form from '@/features/form'
import { FileUpload, PRESETS } from '@/features/files'
import { FormData } from '../../hooks/useGoodieForm'

export default function MessageFields() {
  const { t } = useLingui()

  return (
    <div className="flex flex-col items-center">
      <Form.Field<FormData>
        name="files"
        label={t`Gallery`}
        description={t({
          comment: 'Description of the Gallery Field for the Goodie',
          message:
            "Goodies that don't have Images/Videos can't be shown on the Feed."
        })}
        rules={{
          validate: {
            required(files) {
              if (!files || !Array.isArray(files) || files.length !== 1) {
                return t`This field is required`
              }
            }
          }
        }}
      >
        {({
          renderProps: { value, onChange, ...props },
          locale,
          isDefaultLocale
        }) => (
          <div className="flex flex-row justify-center">
            <FileUpload
              locale={locale}
              isDefaultLocale={isDefaultLocale}
              onChange={file => onChange([file])}
              value={value[0]}
              accept="image/*,video/*"
              placeholder={t`Upload Files`}
              crop={{
                aspectRatio: 2 / 3,
                shape: 'rect',
                allowPadding: false
              }}
              imageResize={PRESETS.DEFAULT}
              {...props}
              className="w-64"
            />
          </div>
        )}
      </Form.Field>
    </div>
  )
}
